import {Box, useTheme} from '@mui/material';
import AppCard from 'main/core/AppCard';
import {getTagColor} from 'main/utility/helper/Utils';
import PropTypes from 'prop-types';
import {Fonts} from 'shared/constants/AppEnums';
import StatusGraph from './StatusGraph';

const StockOverview = (props) => {
  const {data} = props;
  const theme = useTheme();

  return (
    <AppCard sxStyle={{height: 1}} title='Stock Status'>
      <StatusGraph data={data} />

      <Box
        sx={{
          pl: {xl: 5},
          // pt: 5,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-around',
          // mb: -4,
        }}
      >
        {data.map((item, i) => {
          const color = getTagColor(theme, item.color);
          return (
            <Box key={i} sx={{px: 3, flex: 1, mb: 4}}>
              <Box
                component='h3'
                sx={{
                  fontSize: 18,
                  fontWeight: Fonts.SEMI_BOLD,
                  color: color,
                }}
              >
                {item.value}
              </Box>
              <Box
                component='span'
                sx={{
                  color: 'text.secondary',
                  fontSize: 14,
                }}
              >
                {item.name}
              </Box>
            </Box>
          );
        })}
      </Box>
    </AppCard>
  );
};

export default StockOverview;

StockOverview.defaultProps = {
  data: [],
};

StockOverview.propTypes = {
  data: PropTypes.array,
};
